import React from 'react';

import { Box } from '@material-ui/core';

import Loader from '../../../../components/LoaderSplash/Loader.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import LandingNext from '../../Landing/Next';
// import LandingSura from '../../Landing/Sura';
// import RegisterFormSura from './components/RegisterForm';
import { useErrorHandling, useRegister } from '../hook';

const RegisterSura = () => {
  const { isLoading, isError, error, handleSubmit: onSubmit } = useRegister();
  const { open, dialog, handleClose } = useErrorHandling(
    !isLoading && isError,
    error
  );
  if (isLoading) {
    return (
      <Box display="block">
        <Loader action={'Registrando...'} />
      </Box>
    );
  }

  return (
    <>
      <SharedDialog
        open={open}
        onClose={handleClose}
        title={dialog?.title}
        content={dialog?.content}
        actions={dialog?.action}
      />
      {/* <LandingSura childrenName="RegisterSura">
        <RegisterFormSura onSubmit={onSubmit} />
      </LandingSura> */}
      <LandingNext />
    </>
  );
};

RegisterSura.displayName = 'RegisterSura';
export default RegisterSura;
